export const REQUEST_MASTER_ADDDISH = "REQUEST_MASTER_ADDDISH";
export const SET_MASTER_ADDDISH = "SET_MASTER_ADDDISH";
export const ERROR_GET_MASTER_ADDDISH = "ERROR_GET_MASTER_ADDDISH";

export const REQUEST_CREATE_MASTER_ADDDISH = "REQUEST_CREATE_MASTER_ADDDISH";
export const SUCCESS_CREATE_MASTER_ADDDISH = "SUCCESS_CREATE_MASTER_ADDDISH";
export const ERROR_CREATE_MASTER_ADDDISH = "ERROR_CREATE_MASTER_ADDDISH";

export const REQUEST_UPDATE_MASTER_ADDDISH = "REQUEST_UPDATE_MASTER_ADDDISH";
export const SUCCESS_UPDATE_MASTER_ADDDISH = "SUCCESS_UPDATE_MASTER_ADDDISH";
export const ERROR_UPDATE_MASTER_ADDDISH = "ERROR_UPDATE_MASTER_ADDDISH";

export const REQUEST_DELETE_MASTER_ADDDISH = "REQUEST_DELETE_MASTER_ADDDISH";
export const SUCCESS_DELETE_MASTER_ADDDISH = "SUCCESS_DELETE_MASTER_ADDDISH";
export const ERROR_DELETE_MASTER_ADDDISH = "ERROR_DELETE_MASTER_ADDDISH";

export const SET_MESSAGE_MASTER_ADDDISH = "SET_MESSAGE_MASTER_ADDDISH";
